/** A pointer position at a moment, for the speed of a drag. */
export interface TrailPoint {
  x: number
  y: number
  t: number
}

/** How much of its speed a released drag keeps from one frame to the next. */
export const GLIDE_FRICTION = 0.92

/** Below this speed, in pixels per frame, a glide has stopped. */
export const GLIDE_STOP = 0.3

/** How many recent pointer positions a drag keeps for its release speed. */
export const TRAIL_LENGTH = 5

/**
 * The page's speed when a drag is let go, in pixels per frame (~16 ms), from the last few pointer
 * positions, in the direction the pointer moved. Zero when the pointer had stopped before release:
 * holding still and letting go is a placement, not a throw.
 */
export function releaseVelocity(
  trail: readonly TrailPoint[],
  now: number,
): { vx: number; vy: number } {
  const first = trail[0]
  const last = trail[trail.length - 1]
  if (!first || !last || first === last || now - last.t > 80) return { vx: 0, vy: 0 }
  const dt = Math.max(1, last.t - first.t)
  return { vx: ((last.x - first.x) / dt) * 16, vy: ((last.y - first.y) / dt) * 16 }
}
